module.exports = __webpack_public_path__ + "img/map.a4465a58.jpg";